module.exports = __webpack_public_path__ + "img/part03.309cee5c.png";